import React from 'react';

export const Button = ({ children, className, ...props }) => (
  <button className={`px-4 py-2 rounded-md ${className}`} {...props}>
    {children}
  </button>
);

export const Input = ({ className, ...props }) => (
  <input className={`px-4 py-2 rounded-md ${className}`} {...props} />
);

export const Card = ({ children, className }) => (
  <div className={`rounded-lg shadow-lg ${className}`}>{children}</div>
);